import { defineStore } from "pinia";

import { getCompanyId } from "@/utils/userUtils";

import waybillsApi from "@/services/api/waybillsApi";

import { useNotificationStore } from "@/stores/notificationStore";

export const useWaybillStore = defineStore("waybill", {
  state: () => ({
    waybills: [],
    selectedWaybill: null,
    companyId: getCompanyId(),
    dataIsLoading: false,
    isSubmitting: false,
    pagination: {
      page: 1,
      pages: 1,
      series: [],
      next: null,
      prev: null,
      count: 0,
      limit: 40,
      from: 0,
      to: 0,
    },
  }),

  actions: {
    async fetchWaybills(params = {}) {
      this.dataIsLoading = true;
      try {
        const response = await waybillsApi.index(this.companyId, params);
        this.waybills = response.data.result;
        const meta = response.data.pagination_meta;
        if (meta) {
          this.pagination.page = meta.current_page;
          this.pagination.pages = meta.total_pages;
          this.pagination.count = meta.count;
          this.pagination.from = meta.from;
          this.pagination.to = meta.to;
        }
      } finally {
        this.dataIsLoading = false;
      }
    },

    async fetchWaybill(id) {
      this.dataIsLoading = true;
      try {
        const response = await waybillsApi.show(this.companyId, id);
        this.selectedWaybill = response.data.result;
      } finally {
        this.dataIsLoading = false;
      }
    },

    async createWaybill(data) {
      this.isSubmitting = true;
      try {
        await waybillsApi.create(this.companyId, data);
        useNotificationStore().showSuccess("Путевой лист создан");
        await this.fetchWaybills();
      } finally {
        this.isSubmitting = false;
      }
    },

    async updateWaybill(id, data) {
      this.isSubmitting = true;
      try {
        await waybillsApi.update(this.companyId, id, data);
        useNotificationStore().showSuccess("Путевой лист обновлён");
        await this.fetchWaybills();
      } finally {
        this.isSubmitting = false;
      }
    },

    async deleteWaybill(id) {
      this.isSubmitting = true;
      try {
        await waybillsApi.destroy(this.companyId, id);
        useNotificationStore().showSuccess("Путевой лист удалён");
        await this.fetchWaybills();
      } finally {
        this.isSubmitting = false;
      }
    },

    async deleteWaybills(waybills, params = {}) {
      this.isSubmitting = true;
      try {
        const ids = waybills.map((waybill) => waybill.id || waybill);

        await Promise.all(
          ids.map((id) => waybillsApi.destroy(this.companyId, id))
        );

        useNotificationStore().showSuccess(
          `Удалено путевых листов: ${ids.length}`
        );
        await this.fetchWaybills(params);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
});
